import { Anchor, Box, Button, Image, Sidebar, Text } from 'grommet';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export interface AppSidebarProps {}

export interface INavLink {
  label: string;
  url: string;
  title: string;
}

export interface INavSection {
  title: string;
  links: INavLink[];
}

const AppSidebar: React.FC<AppSidebarProps> = (): JSX.Element => {
  const navigate = useNavigate();

  const onNavClick = (url: string): void => {
    navigate(url);
  };

  const onLogoClick = (): void => {
    navigate('/');
  };

  const navSections: INavSection[] = [
    {
      title: 'Identity',
      links: [
        { label: 'Manage Users', url: '/owner/manageUsers', title: 'Go to Manage Users' },
        { label: 'Manage Companies', url: '/owner/manageCompanies', title: 'Go to Manage Companies' },
        { label: 'Manage Instructors', url: '/owner/manageInstructors', title: 'Go to Manage Instructors' },
        { label: 'Loading', url: '/loading', title: 'Go to Loading' },
      ],
    },
    {
      title: 'Dashboard',
      links: [
        { label: 'Overview', url: '/dashboard', title: 'Go to Dashboard Overview' },
        { label: 'Reports', url: '/dashboard/reports', title: 'View reports' },
        { label: 'Analytics', url: '/dashboard/analytics', title: 'View analytics' },
      ],
    },
    {
      title: 'Users',
      links: [
        { label: 'All Users', url: '/users', title: 'Manage users' },
        { label: 'Roles', url: '/users/roles', title: 'Manage roles' },
        { label: 'Permissions', url: '/users/permissions', title: 'Manage permissions' },
      ],
    },
  ];

  const odlOnClick = (): void => {
    window.open('https://learning.pragmaticworkstraining.com/', '_blank');
  };

  return (
    <Sidebar
      background="brand"
      pad="xsmall"
      fill="vertical"
      header={
        <Image
          title="Pragmatic Works Training"
          src="/logo.png"
          height={100}
          onClick={onLogoClick}
          style={{ cursor: 'pointer' }}
        />
      }
      footer={
        <Box
          fill="horizontal"
          alignContent="center"
          align="center"
        >
          <Button
            title="ODL"
            label="ODL"
            primary
            onClick={odlOnClick}
          />
        </Box>
      }
    >
      <Box
        background="rgb(30, 118, 178)"
        pad="medium"
        width="small"
        gap="medium"
        fill="horizontal"
      >
        {navSections.map(section => (
          <Box key={section.title}>
            <Box
              background="rgba(255,255,255,0.1)"
              pad={{ vertical: 'xsmall', horizontal: 'small' }}
              round="xsmall"
              margin={{ bottom: 'xsmall' }}
            >
              <Text weight="bold" color="white" size="small">
                {section.title.toUpperCase()}
              </Text>
            </Box>
            <Box gap="xsmall">
              {section.links.map(link => (
                <Anchor
                  key={link.url}
                  label={link.label}
                  title={link.title}
                  color="white"
                  size="small"
                  onClick={() => onNavClick(link.url)}
                />
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Sidebar>
  );
};

AppSidebar.displayName = 'AppSidebar';

export default AppSidebar;
